exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[dir] .formBuilder_container__24nee{background-color:rgba(0,0,0,0)}", ""]);

// Exports
exports.locals = {
	"container": "formBuilder_container__24nee"
};